
style= require('./player-list-modal.styl')

.player-list-modal
  .modal-header
    .team-badge
      if team?.logo
        img(src=team.logo)
      else
        .badge-placeholder= team?.name?.charAt(0)
    .team-name= team?.name || 'Team'

  .players-list
    each player in players
      - var isUnavailable = this.isPlayerUnavailable(player)
      .player-item(
        (click)= this.selectPlayer(player),
        class= isUnavailable ? 'unavailable' : ''
      )
        .player-number= player.shirt
        .player-info
          .player-name= player.firstName + ' ' + player.lastName
          .player-position= player.position?.toUpperCase() || 'N/A'
        .player-status(
          class= isUnavailable ? 'unavailable' : ''
        )= isUnavailable ? 'Unavailable' : 'Expected'
